import axios from "@/lib/axios";

const getCancelRequest = () => {
  return axios.get("/customer/flat_rates/cancel_request");
}

export default getCancelRequest;